// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"21933454","977":"0369d39b"}[chunkId] + ".chunk.js";
};